import { render, staticRenderFns } from "./PatientResultsScoring.vue?vue&type=template&id=15f5bf44&scoped=true&"
import script from "./PatientResultsScoring.vue?vue&type=script&lang=ts&"
export * from "./PatientResultsScoring.vue?vue&type=script&lang=ts&"
import style0 from "./PatientResultsScoring.vue?vue&type=style&index=0&id=15f5bf44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5bf44",
  null
  
)

export default component.exports